import { createEvent } from 'effector';

export const changeGradientTypeEv = createEvent();
